import { getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    getUser: (id) => getRequest(`/users/${id}`),
    updateUser: (id, body) => patchRequest(`/users/${id}`, body),
    createProfileImageUpload: (id, body) => postRequest(`/users/${id}/profile-image-upload`, body),
    createProfileImageUrl: (id, body) => postRequest(`/users/${id}/profile-image-url`, body),
    getUserCustomer: (id) => getRequest(`/users/${id}/customers`),
    getUserEntitlements: (id, customerId) => getRequest(`/users/${id}/customers/${customerId}/entitlements`),
    getUserPaymentIntents: (id, customerId) => getRequest(`/users/${id}/customers/${customerId}/payment-intents`),
    getUserPaymentMethod: (id, customerId) => getRequest(`/users/${id}/customers/${customerId}/payment-methods`),
    getUserSubscriptionSchedule: (id, customerId, subscriptionScheduleId) => {
        return getRequest(`/users/${id}/customers/${customerId}/subscription-schedules/${subscriptionScheduleId}`);
    },
    getUserSubscriptions: (id, customerId) => getRequest(`/users/${id}/customers/${customerId}/subscriptions`),
    getAssignmentDefaults: async (id) => {
        const response = await getRequest(`/users/${id}/assignment-defaults`);
        return response?.defaults || null;
    },
    updateAssignmentDefaults: (id, defaults) => patchRequest(`/users/${id}/assignment-defaults`, { defaults }),
};

export default services;
